import { CommonModule } from '@angular/common';
import { Component, computed, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { DxTextBoxComponent, DxTextBoxModule } from 'devextreme-angular';
import { ApplicationInfoService } from '../core/application-info.service';
import { StoreService } from '../core/store.service';

@Component({
    selector: 'app-header',
    imports: [CommonModule, RouterLink, RouterLinkActive, FormsModule, DxTextBoxModule],
    template: `
        <div class="header-items">
            <div class="overlayOffCanvas" [class.show]="menuOpen" (click)="closeMenu()"></div>
            <div class="responsive-nav-wrapper-parent">
                <div class="responsive-nav-wrapper">
                    <div class="responsive-nav-inner">
                        <!-- <div class="personal-button" id="header-links-opener" (click)="openMenu()"><span>Personal menu</span></div> -->
                        <div class="menu-title" (click)="openMenu()"><span>Menu</span></div>
                        <div class="search-wrap">
                            <a routerLink="/search"> <span>Search</span></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="subheader-wrapper">
                <div class="logo-wrapper">
                    <div class="header-logo">
                        <a [href]="homeHref()" class="logo">
                            <img alt="{{ appInfo.info.companyName }} Logo" title="{{ appInfo.info.companyName }}" src="{{ logoUrl }}"
                        /></a>
                    </div>
                </div>
                <div class="headerMenuParent">
                    <div class="header-menu flex-column" [class.open]="menuOpen">
                        <div class="close-menu" (click)="closeMenu()"><span>Close</span></div>
                        <ul class="mega-menu">
                            @if (!showSearch) {
                                @if (!appInfo.isPPM()) {
                                    <li>
                                        <a [href]="homeHref()" routerLinkActive="active" title="Home"><span> Home</span></a>
                                    </li>
                                    <li>
                                        <a [href]="aboutHref()" routerLinkActive="active" title="About"><span> About</span></a>
                                    </li>
                                    <li>
                                        <a routerLink="/products" routerLinkActive="active" title="Products"><span> Products</span></a>
                                    </li>
                                    <li>
                                        <a [href]="blogHref()" routerLinkActive="active" title="Blog"><span> Blog</span></a>
                                    </li>
                                    <li>
                                        <a [href]="contactHref()" routerLinkActive="active" title="Contact us"><span> Contact us</span></a>
                                    </li>
                                } @else {
                                    <li>
                                        <a routerLink="/" routerLinkActive="active" title="Home"><span> Home</span></a>
                                    </li>
                                    <li>
                                        <a routerLink="/about" routerLinkActive="active" title="About"><span> About</span></a>
                                    </li>
                                    <li>
                                        <a routerLink="/products" routerLinkActive="active" title="Products"><span> Products</span></a>
                                    </li>
                                    <li>
                                        <a routerLink="/contact-us" routerLinkActive="active" title="Contact us"
                                            ><span> Contact us</span></a
                                        >
                                    </li>
                                }
                                <li></li>
                            } @else {
                                <li class="search">
                                    <dx-text-box
                                        #searchComponent
                                        placeholder="Search for products..."
                                        (onEnterKey)="search()"
                                        [(value)]="searchValue"
                                    >
                                    </dx-text-box>
                                    <a (click)="toggleShowSearch()">x</a>
                                </li>
                            }
                            <li class="cart">
                                <a title="Search" (click)="toggleShowSearch()" class="ico ico-search">
                                    <i class="fas fa-solid fa-search fa-flip-horizontal"></i>
                                </a>
                                <a routerLink="/checkout/cart" class="ico ico-cart">
                                    <i class="fas fa-solid fa-shopping-cart"></i>
                                </a>
                                <a routerLink="/sign-in" class="ico ico-sign-in">
                                    <i class="fas fa-solid fa-sign-in"></i>
                                </a>
                            </li>
                        </ul>
                        <div class="menu-title"><span>Menu</span></div>
                        <ul class="mega-menu-responsive">
                            @if (!appInfo.isPPM()) {
                                <li>
                                    <a [href]="homeHref()" routerLinkActive="active" title="Home" (click)="closeMenu()">
                                        <span> Home</span>
                                    </a>
                                </li>
                                <li>
                                    <a routerLink="/products" routerLinkActive="active" title="Products" (click)="closeMenu()">
                                        <span> Products</span>
                                    </a>
                                </li>
                                <li>
                                    <a [href]="contactHref()" routerLinkActive="active" title="Contact us" (click)="closeMenu()">
                                        <span> Contact us</span>
                                    </a>
                                </li>
                            } @else {
                                <li>
                                    <a routerLink="/" routerLinkActive="active" title="Home" (click)="closeMenu()"><span> Home</span></a>
                                </li>
                                <li>
                                    <a routerLink="/products" routerLinkActive="active" title="Products" (click)="closeMenu()">
                                        <span> Products</span>
                                    </a>
                                </li>
                                <li>
                                    <a routerLink="/contact-us" routerLinkActive="active" title="Contact us" (click)="closeMenu()">
                                        <span> Contact us</span>
                                    </a>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    `,
    styles: `
        .header-items {
            display: block;
            justify-content: space-between;
            align-items: center;

            .logo-wrapper {
                width: auto;
            }

            .header-logo {
                height: 102px;
                margin-right: 50px;
                flex-grow: 1;

                .logo {
                    max-width: unset;
                }

                img {
                    max-width: 100%;
                    height: 102px;
                }
            }

            .header-selectors-wrapper {
                display: flex;
                flex-direction: column;
                gap: 10px;
            }

            .header-menu {
                display: flex;
                gap: 10px;
                align-items: center;

                .mega-menu {
                    display: flex;
                    gap: 10px;
                    align-items: center;
                    width: 100%;
                }
            }

            .header-links {
                align-self: flex-end;
                a {
                    font-size: 13px;
                }
            }

            .cart-qty {
                font-size: 11px;
                right: -18px;
            }

            .search {
                width: 70%;
                display: flex;
                align-items: center;
                gap: 10px;

                dx-text-box {
                    flex-grow: 1;
                }
            }

            .overlayOffCanvas.show {
                display: block;
            }

            .cart {
                margin-left: auto;
                margin-bottom: 0;
            }

            .ico {
                display: inline-block;
                color: #fff;
                font-size: 20px;
                margin-left: 25px;
            }
        }

        @media (max-width: 1024px) {
            .mega-menu-responsive,
            .close-menu {
                width: 100%;
            }

            .header-items {
                .header-logo {
                    height: auto;
                    margin-right: 0;

                    img {
                        height: 70px;
                    }
                }
            }

            .mega-menu {
                display: none !important;
            }
        }
    `
})
export class HeaderComponent {
    router = inject(Router);
    route = inject(ActivatedRoute);
    storeService = inject(StoreService);
    appInfo = inject(ApplicationInfoService);

    homeHref = computed(() => this.appInfo.addUtm(this.wordpressUrl));
    aboutHref = computed(() => this.appInfo.addUtm(`${this.wordpressUrl}/about`));
    blogHref = computed(() => this.appInfo.addUtm(`${this.wordpressUrl}/blog`));
    contactHref = computed(() => this.appInfo.addUtm(`${this.wordpressUrl}/contact-us`));

    wordpressUrl = this.appInfo.info.wordPressUrl;
    logoUrl = this.appInfo.isPPM() ? '/assets/images/ppp-logo-500.jpg' : '/assets/images/logo-transparent-white.png';
    showSearch: boolean = false;
    searchValue: string = '';
    menuOpen: boolean = false;

    openMenu() {
        this.menuOpen = true;
    }

    closeMenu() {
        this.menuOpen = false;
    }

    @ViewChild('searchComponent') searchComponent?: DxTextBoxComponent;

    search() {
        const searchValue = this.searchValue;
        this.searchValue = '';
        this.showSearch = false;

        this.router.navigate(['/search'], {
            relativeTo: this.route,
            queryParams: { search: searchValue ? searchValue : undefined }
        });
    }

    toggleShowSearch() {
        this.showSearch = !this.showSearch;
        if (this.showSearch) {
            setTimeout(() => {
                this.searchComponent!.instance.focus();
            });
        }
    }
}
